export default {
  fontFamily: "vi-font-family",
  classLang: "vi",
  headlist: [
    // {
    //   text: "Trang chủ",
    //   url: "/",
    // },
    {
      text: "Giao dịch",
      menu: [
        {
          tit: "Sản phẩm giao dịch",
          list: [
            {
              text: "Ngoại hối",
              url: "/tradingproduct?index=0",
            },
            {
              text: "Hàng hóa",
              url: "/tradingproduct?index=1",
            },
            {
              text: "Chỉ số",
              url: "/tradingproduct?index=2",
            },
            {
              text: "Cổ phiếu",
              url: "/tradingproduct?index=3",
            },
            {
              text: "ETF",
              url: "/tradingproduct?index=4",
            },
          ],
        },
        {
          tit: "Tài khoản & Điều kiện",
          list: [
            {
              text: "Tài khoản giao dịch",
              url: "/TradingAccount",
            },
            // {
            //   text: "Sản phẩm giao dịch",
            //   url: "/tradingproduct",
            // },
            {
              text: "Quỹ đảm bảo/ đòn bẩy",
              url: "/leverage-margin",
            },
            {
              text: "Nạp/Rút tiền",
              url: "/funding",
            },
            {
              text: "Cổ tức",
              url: "/dividend",
            },{
              text: "Giải pháp thanh khoản",
              url: "/service",
            },
            {
              text: "Chương trình liên kết",
              url: "/technology",
            },
          ],
        },
        {
          tit: "Công cụ giao dịch",
          list: [
            {
              text: "Tải xuống MT4",
              url: "/MT4",
            },
            {
              text: "Tải xuống MT5",
              url: "/MT5",
            },
            {
              text: "Giao dịch EA và các chỉ báo",
              url: "/tools",
            },
            {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "Phân tích thị trường",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "Viện nghiên cứu EBC",
      menu: [
        {
          tit: "",
          list: [
            {
              text: "Trung tâm học tập",
              url: "/LearningCenter",
            },
          ],
        },
      ],
    },
    
   
    {
      text: "Về EBC",
      menu: [
        {
          tit: "Về EBC",
          list: [
            {
              text: "WHY EBC",
              url: "/about-us",
            },
            {
              text: "Trách nhiệm xã hội",
              url: "/ESG",
            },
            {
              text: "Tin tức EBC",
              url: "/LearningCenter?tabId=1",
            },
            {
              text: "FAQ",
              url: "https://support.ebchelp.com/hc/en-001",
            },
            {
              text: "Xác minh kênh chính thức",
              url: "/official-verification",
            },
          ],
        },
        {
          tit: "Mẫu hợp tác",
          list: [
            {
              text: "FC Barcelona",
              url: "/FCB",
            },
            {
              text: "Đại học Oxford",
              url: "/partners/oxford",
            },
            {
              text: "Quan hệ đối tác",
              url: "/affiliate-programmes",
            },
            // {
            //   text: "Cơ chế phục vụ",
            //   url: "/service",
            // },
            // {
            //   text: "Công nghệ nền tảng",
            //   url: "/technology",
            // },
          ],
        },
      ],
    },
    {
      text: "Các hoạt động",
      url: "",
      menu: [
        {
          tit: "Kegiatan Populer EBC",
          list: [
            {
              text: "Cuộc Thi Giao Dịch Triệu Đô EBC II",
              url: "/million-dollar-challenge-2",
            },
            
            {
              text: "Nhận Chi Trả Hàng Tháng",
              url: "/pay",
            },{
              text: "Các sự kiện khác",
              url: "/activity",
            },
           
          ],
        },
      ],
    },
  ],
  FCA开户: "Tài khoản FCA",
  立即开户: "Đăng ký",
  登录: "Đăng nhập",
  官方验证: "Xác minh kênh chính thức",
  帮助中心: "FAQ",
  帮助中心Url: "https://support.ebchelp.com/hc/en-001",
};
